export default __webpack_public_path__ + "static/media/bannertwitter.7f4d6e94.jpeg";